import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    packagesDeletePackageRequest,
    clearRedux,
} from 'Redux/actions';


const DeletePackage = (props) => {
    const { tableRef } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { openModal, loading, result, roleId } = useSelector(state => state.deletePackageRedux)

    const closeModal = () => {
        dispatch(clearRedux("DELETE_PACKAGE"))
    }

    const applyChanges = () => {
        roleId && dispatch(packagesDeletePackageRequest(roleId));
    }

    useEffect(() => {
        if (result) {
            if (result?.delete) {
                NotificationManager.success(
                    messages['packages_delete_package_success_message'],
                    messages['packages_delete_package_title'],
                    3000,
                );
                tableRef && tableRef?.current?.getData();
                closeModal();
            } else {
                let message = messages['packages_delete_package_error_message']
                if(result && result?.error && result?.error?.includes("in use")){
                    message = messages['packages_delete_package_in_use']
                }

                NotificationManager.error(
                    message,
                    messages['packages_delete_package_title'],
                    3000,
                );
                dispatch(clearRedux("DELETE_PACKAGE", { result: null }))
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['packages_delete_package_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <p>{messages['packages_delete_package_description']}</p>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )

}

export default DeletePackage;